import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => {
    return {
        wrapper: {
            // maxWidth: '100%',
            // '&::-webkit-scrollbar': {
            //     display: 'none'
            // },
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
            // flex: 1,
            // overflow: 'hidden'
        },
        tableWrapper: {
            flex: 1,
            overflow: 'auto'
        },
        headerRow: {
            background: theme.fn.gradient({
                from: theme.other.gradientFrom,
                to: theme.other.gradientTo,
                deg: 270
            }),
        },
        paginationWrapper: {
            justifyContent: 'space-between',
            display: 'flex',
            alignItems: 'center',
            marginTop: theme.spacing.xs
        },
        pagination: {
            display: 'flex',
            gap: theme.spacing.xs - 5,
        },
        paginationIcon: {
            fontSize: 25
        },
        quickJumper: {
            width: 50
        },
        pageSize: {
            width: 80
        },
        header: {
            marginBottom: 10,
            display: 'flex',
            alignItems: 'flex-end'
        }
    }
})